/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IBackdropProps extends React.ComponentPropsWithRef<"div"> {
	className?: string;
}

export const Backdrop: React.FC<IBackdropProps> = ({ className, ...props }) => {
	const baseClass = BEM("edt-backdrop");

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()} {...props} />;
};
